export const TASK_TYPE = 'router';

export const SESSION_RESUME_THRESHOLD_WITH_FLOW = 10;
export const SESSION_RESUME_THRESHOLD_WITHOUT_FLOW = 90;

export const SAMPLE_IDEAS = (t: any) => [
  t('Tell me about the Kizen agentic workflow engine'),
  t('Filter My Data'),
  t('Update My Custom Object'),
  t('Create a new form'),
  t('Tell me what you can do?'),
  t('Design an email'),
  t('How can I optimize my workflow?'),
  t('I need help with an integration'),
];
